import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/iphone-new/banner_iphone.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service iphone_banner cloud_mig"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Cloud Migration Services
              </h1>
              <span style={{ color: "#000" }}>
                Automate. Authenticate. Scale.
              </span>
              <p style={{ color: "#898989" }}>
                TekRevol's cloud migration services help businesses seamlessly
                transition applications and databases to the cloud with
                precision and efficiency. Since 2018, our seasoned cloud experts
                have been designing and executing secure, scalable, and
                cost-effective strategies through reliable cloud migration
                consulting. Drive innovation and growth with cloud-powered
                legacy software across business functions.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult Your Cloud Needs
              </Link>
            </div>
          </Col>
          <Col xs={12} md={4} lg={5} xl={5} xxl={5} className="my-auto">
            <StaticImage
              src="../../images/services-usa/cloud-mig/cloud_mig_banner_img.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={923}
              height={713}
            />
            {/* <img src={GIF} alt="TekRevol" /> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
